<script setup>
  import { ref, watchEffect, watch, onMounted} from 'vue';
  import { useUserStore } from '@/stores/UserStore'
  import BaseModal from './base/BaseModal.vue';
  import ModalContentTextInput from '@/components/ModalContentTextInput.vue';
  import { useToaster } from '@/composables/useToaster';
  
  const emits = defineEmits(['close']);

  const props = defineProps({
    containerId: {
      type: Number,
      required: false
    },
    show: {
      type: Boolean,
      default: false
    },  
  });

  const userStore = useUserStore();
  const toaster = useToaster();

  const containerName = ref(``);
  const showModal = ref(false); 

  function closeModal() {
    showModal.value = false;

    emits('close');
  }

  async function updateContainerName() {
    await userStore.updateProfileContainer(props.containerId, containerName.value);
    await userStore.getProfiles(true);

    toaster.toast({
      type: 'success',
      content: `Renamed container to ${containerName.value}.`,
    })

    closeModal();
  }

  onMounted(() => {
    watchEffect(() => showModal.value = props.show);
  });

  watch(() => props.containerId, () => {
    containerName .value = userStore.getContainerById(props.containerId).container_name;
  }, { immediate: true });

</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="false"
  >
    <ModalContentTextInput
      v-model="containerName"
      :modalTitle="`Rename ${containerName}`"
      labelText="Name"
      acceptButtonText="Save"
      @accept="updateContainerName"
      @cancel="closeModal"
    /> 
  </BaseModal>
</template>